import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function OtherChoicesComponent(props) {
  const { t } = useTranslation();
  const { dataOtherChoices } = props;

  return (
    <div className="other-choice">
      <div className="title">{t('servicedOffice.label_otherChoices')}</div>
      <div className="d-flex row">
        {dataOtherChoices.map((item, index) => (
          <div key={index} className="col-12 col-md-4 mb-4">
            <Link to={item.to}>
              <div
                style={{
                  backgroundImage: `url(${process.env.REACT_APP_ISN_IMAGE_URL}${item.imageUrl})`,
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'center center',
                  backgroundSize: 'cover',
                }}
              >
                <div className="d-flex flex-column align-items-center justify-content-center other-choice__info">
                  <div className="other-choice__info--title text-center">{item.title}</div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default OtherChoicesComponent;
